module.exports = __webpack_public_path__ + "media/images/splash-screen/BG Shape-6b42b1d7d911c3d7f97fab2e78c06688.svg";